import { render, staticRenderFns } from "./_attachments.vue?vue&type=template&id=6ade8b82"
import script from "./_attachments.vue?vue&type=script&lang=js"
export * from "./_attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports